"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogLevel = exports.LogLevelIterable = void 0;
exports.LogLevelIterable = ['debug', 'info', 'warn', 'error'];
exports.LogLevel = {
    Debug: 'debug',
    Info: 'info',
    Warn: 'warn',
    Error: 'error',
};
//# sourceMappingURL=Log.js.map